export default __webpack_public_path__ + "static/media/unacceptable-photo.81cbab10.png";